import {
  createSubscription as createSubscriptionService,
  getUserSubscription as getUserSubscriptionService,
} from "services/subscription/subscriptionService";
import {
  createSubscriptionStart,
  createSubscriptionSuccess,
  createSubscriptionFailure,
  getUserSubscriptionStart,
  getUserSubscriptionSuccess,
  getUserSubscriptionFailure,
} from "./subscriptionSlice";
import { showSuccessToast, showErrorToast } from "utils/toastNotification";

// Create Subscription
export const createUserSubscription = (planId) => async (dispatch) => {
  try {
    dispatch(createSubscriptionStart());
    const result = await createSubscriptionService(planId);

    if (result?.meta?.status === true && result?.meta?.code === 200) {
      dispatch(createSubscriptionSuccess(result.data));
      showSuccessToast(
        result.meta.message || "Subscription created successfully!"
      );
      return { success: true, data: result.data };
    } else {
      const errorMsg = result?.meta?.message || "Failed to create subscription";

      // Handle "subscription already exists" case
      if (errorMsg.toLowerCase().includes("already exists")) {
        showErrorToast("You already have an active subscription!");
        return { success: false, error: errorMsg, alreadyExists: true };
      }

      dispatch(createSubscriptionFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  } catch (error) {
    console.error("Create subscription error:", error);
    const errorMsg =
      error?.response?.data?.meta?.message ||
      error.message ||
      "Failed to create subscription";

    if (errorMsg.toLowerCase().includes("already exists")) {
      showErrorToast("You already have an active subscription!");
      return { success: false, error: errorMsg, alreadyExists: true };
    }

    dispatch(createSubscriptionFailure(errorMsg));
    showErrorToast(errorMsg);
    return { success: false, error: errorMsg };
  }
};

// fetch user's subscriptions
export const fetchUserSubscription = () => async (dispatch) => {
  try {
    dispatch(getUserSubscriptionStart());
    const result = await getUserSubscriptionService();

    if (result?.meta?.status === true && result?.meta?.code === 200) {
      dispatch(getUserSubscriptionSuccess(result.data));
      return { success: true, data: result.data };
    } else {
      const errorMsg = result?.meta?.message || "No active subscription found";
      dispatch(getUserSubscriptionFailure(errorMsg));
      return { success: false, error: errorMsg };
    }
  } catch (error) {
    console.error("Fetch subscription error:", error);
    const errorMsg =
      error?.response?.data?.meta?.message ||
      error.message ||
      "Failed to fetch subscription";
    dispatch(getUserSubscriptionFailure(errorMsg));
    return { success: false, error: errorMsg };
  }
};
